import RequestError from 'flarum/common/utils/RequestError';
import {SubmissionValidationErrors} from '../models/JsonTypes';

// We will use this value later in substr() to easily remove the start of the error pointer string
const IGNORE_FROM_POINTER_START = '/data/attributes/'.length;

export default function (error: RequestError) {
    const errorTree = {};

    error.response?.errors?.forEach(error => {
        let lastLocationInTree: SubmissionValidationErrors = errorTree;

        // Each error has a path in the form /data/attributes/firstlevelfield/secondlevelfield
        // There could be any number of levels as we allow nesting fields in the forms
        // We extract the key for each level
        const keyPath: string[] = (error as any)?.source?.pointer?.substr(IGNORE_FROM_POINTER_START).split('/');

        keyPath.forEach(key => {
            if (lastLocationInTree[key]) {
                // If the path already exists in the tree, we follow it
                lastLocationInTree = lastLocationInTree[key];
            } else {
                // if it doesn't exist, we add a new object and follow that new object
                const newLocation: SubmissionValidationErrors = {};
                lastLocationInTree[key] = newLocation;
                lastLocationInTree = newLocation;
            }
        });

        // We cannot simply place the array of details at the given key, because both the parent and nested fields could have errors
        // (example: invalid number of sub-items AND invalid formatting in a sub item field)
        lastLocationInTree.errors = (Array.isArray(error.detail) ? error.detail : [error.detail]) as any;
    });

    return errorTree;
}
